/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'more': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M18.874 24.114a2.886 2.886 0 1 1-5.773 0 2.886 2.886 0 0 1 5.773 0zm5.094-2.885a2.886 2.886 0 1 0 .003 5.773 2.886 2.886 0 0 0-.003-5.773zm7.979 0a2.887 2.887 0 0 0 0 5.772 2.887 2.887 0 0 0 0-5.772z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/more.js